import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuPortal } from "@/components/ui/dropdown-menu";
import { useColonyContext } from "@/hooks/useColonyContext";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

export function KnowledgeColonySelector() {
  const { activeColony, colonies } = useColonyContext();
  const navigate = useNavigate();

  const handleColonySelect = (colonyId: string) => {
    navigate(`/knowledge/${colonyId}`);
  };

  if (!activeColony) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          className={cn(
            "h-8 px-2 text-muted-foreground hover:text-foreground",
            "flex items-center gap-2 max-w-[200px]"
          )}
        >
          <span className="truncate ios-callout">{activeColony.name}</span>
          <ChevronDown size={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent
          align="end"
          sideOffset={8}
          collisionPadding={12}
          className="z-[60] max-w-[320px] w-[min(92vw,320px)] max-h-[60vh] overflow-auto rounded-xl border border-white/10 bg-[#151515] p-2 shadow-2xl"
        >
          {colonies.map((colony) => (
            <DropdownMenuItem
              key={colony.id}
              onClick={() => handleColonySelect(colony.id)}
              className={cn(
                "px-3 py-2 whitespace-normal break-words leading-snug rounded-lg focus:bg-white/10",
                colony.id === activeColony.id && "bg-accent"
              )}
            >
              <div className="font-medium ios-subheadline truncate w-full">{colony.name}</div>
              {colony.description && (
                <div className="text-white/60 text-xs whitespace-normal break-words leading-tight line-clamp-2 w-full" title={colony.description}>
                  {colony.description}
                </div>
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}